import app.App
import app.app
import base.SRProps
import kotlinext.js.js
import kotlinext.js.jsObject
import react.dom.render
import kotlinx.browser.document
import kotlinx.browser.window
import react.child
import react.router.dom.browserRouter

external fun setTitle(title: String?): Unit

fun main() {
    window.onload = {
        render(document.getElementById("root")) {
            browserRouter {
                /*child(App,js{}){

                }*/
                app(jsObject<SRProps>{
                    defaultProps = js {  }
                })
            }

        }
    }
}
